import styled from "styled-components";
import { COLORS } from "styles/colors";
import { FLEX } from "styles/flex";
import { calcRem } from "styles/theme";

export const Row = styled.div`
  ${FLEX.FlexStartCenter};
  gap: 8px;
`;

export const ButtonWrapper = styled(Row)<{ disabled?: boolean }>`
  align-items: flex-end;

  ${({ disabled }) =>
    disabled &&
    `
    opacity: 0.25;
  `}
`;

export const ActiveLabel = styled.span`
  background-color: ${({ theme }) => theme.COLORS.SELECTED};
  color: ${({ theme }) =>
    theme.value === "light" ? COLORS.WHITE : theme.COLORS.BLACK};
  padding: 2px 8px;
  border-radius: 10px;
  font-size: ${calcRem(11)};
  font-weight: 500;
`;

export const FileWrapper = styled.div`
  ${FLEX.FlexStartCenter};
  gap: 8px;
  padding-top: 5px;
  color: ${({ theme }) => theme.COLORS.WHITE};
  font-size: ${calcRem(14)};
  cursor: pointer;
`;
